import React, { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export const DndWrapper = React.memo((props: { id: any; children: any }) => {
  const [context, setContext] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const y = document.getElementById(props.id);
    if (y) {
      setContext(y);
    }
  }, [props.id]);

  return context ? (
    <DndProvider backend={HTML5Backend} options={{ rootElement: context }}>
      {props.children}
    </DndProvider>
  ) : null;
});
